import { createFileRoute } from "@tanstack/react-router";

import { AgentPairing } from "@/features/agent/AgentPairing";

export const Route = createFileRoute("/agent/pairing")({
  component: AgentPairing,
});
